import React from 'react';
import './Services.css';

const services = [
  {
    id: '01',
    title: 'aXtion Telemed',
    description: 'A comprehensive telemedicine platform connecting patients to licensed providers through secure video consultations, real-time messaging, and remote monitoring — delivering quality care from anywhere.',
    tags: ['Telehealth', 'Video Consult', 'Remote Monitoring', 'HIPAA'],
    icon: '⬡',
  },
  {
    id: '02',
    title: 'aXtion Electronic Health Record Systems',
    description: 'A fully integrated EHR system designed for clinics and hospitals of all sizes. Streamline patient records, clinical workflows, billing, and compliance in one secure, interoperable platform.',
    tags: ['EHR', 'HL7 FHIR', 'Clinical Workflow', 'ICD-10'],
    icon: '◈',
  },
  {
    id: '03',
    title: 'aXtion Students Portal',
    description: 'An all-in-one academic management platform for schools and universities. Manage enrollment, course scheduling, grades, attendance, and student communication in a unified digital campus.',
    tags: ['LMS', 'Academic Records', 'Enrollment', 'e-Learning'],
    icon: '▣',
  },
  {
    id: '04',
    title: 'Fintech Integration',
    description: 'Seamless financial technology integration for businesses — payment processing, banking APIs, digital wallets, and compliance-ready fintech infrastructure built for speed and security.',
    tags: ['Payment APIs', 'Digital Wallet', 'PCI-DSS', 'Banking Integration'],
    icon: '◎',
  },
  {
    id: '05',
    title: 'Enterprise Software Solutions',
    description: 'Custom enterprise-grade software tailored to your operational needs — ERP systems, workflow automation, business intelligence dashboards, and scalable cloud deployments across industries.',
    tags: ['ERP', 'Workflow Automation', 'Business Intelligence', 'Cloud'],
    icon: '⧉',
  },
];

const Services = () => {
  return (
    <section id="services" className="services">
      <div className="services-inner">
        <div className="section-header fade-up">
          <span className="section-label">// 01 — Meet Our Services</span>
          <h2 className="section-title">
            Our<br />
            <em>Solutions</em>
          </h2>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div
              key={service.id}
              className="service-card fade-up"
            >
              <div className="card-header">
                <span className="card-id">{service.id}</span>
                <span className="card-icon">{service.icon}</span>
              </div>
              <h3 className="card-title">{service.title}</h3>
              <p className="card-desc">{service.description}</p>
              <div className="card-tags">
                {service.tags.map(tag => (
                  <span key={tag} className="tag">{tag}</span>
                ))}
              </div>
              <div className="card-arrow">→</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
